<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row wrap>
        <v-flex lg9 md8 sm12 xs12 order-lg1 order-md1 order-sm2 order-xs2>
            <v-layout column>
                <v-flex v-if="dashboardId">
                    <v-card v-if="currentDashboard">
                        <div class="keywords-wrapper">
                            <span class="body-2 grey--text keywords-caption">Keywords:</span>
                            <v-chip
                                    :key="keyword"
                                    v-for="keyword in currentDashboard.keywords"
                                    label
                                    color="primary"
                                    text-color="white"
                            >
                                <span class="zawgyi">{{ keyword | textLowerCase | zgtext }}</span>
                            </v-chip>
                        </div>
                    </v-card>
                </v-flex>
                <v-flex v-else>
                    <v-layout row wrap>
                        <v-flex lg7 md7 sm7 xs12>
                            <v-text-field
                                    v-model="filter.keyword"
                                    clearable
                                    label="Search..."
                                    hide-details
                                    solo
                                    append-icon="search"
                                    :disabled="isScanningAdmin"
                                    :background-color="isScanningAdmin ? '#f2f2f2' : ''"
                                    @click:clear="searchKeywordCleared"
                                    @keydown="searchKeywordInput"
                            ></v-text-field>
                        </v-flex>
                        <v-flex lg3 md3 sm3 xs8>
                            <v-select
                                    solo
                                    hide-details
                                    label="Type"
                                    :items="types"
                                    item-text="text"
                                    item-value="value"
                                    @change="filterTypeChanged"
                            ></v-select>
                        </v-flex>
                        <v-flex lg2 md2 sm2 xs4>
                            <v-btn 
                                class="search-btn" 
                                color="primary" 
                                @click="searchKeywordChanged"
                            >Search</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex>
                    <search-stats
                        :stats="searchStats"
                    ></search-stats>
                </v-flex>
                <v-flex v-if="showNoResult">
                    <v-alert
                            :value="true"
                            color="error"
                            icon="warning"
                    >
                        No Results Found!
                    </v-alert>
                </v-flex>
                <v-flex v-if="!showNoResult">
                    <v-card>
                        <v-card-text>
                            <line-chart 
                                :chartData="mentionLineChartData"
                                :options="mentionLineChartOptions"
                                :height="300"
                            />
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex v-if="!showNoResult">
                    <v-card>
                        <v-card-text>
                            <image-bar-chart
                                :chartData="mediaBasedCountsBarChartData"
                                :options="mediaBasedCountsBarChartOptions"
                                :height="300"
                            />
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex :key="item.id" v-for="item in foundJournals">
                    <journal-entry
                            :item="item"
                            @journal-clicked="onJournalClicked"
                            @journal-deleted="onJournalDeleted(item.id)"
                    ></journal-entry>
                </v-flex>
                <v-flex v-if="isLoading">
                    <v-card>
                        <div class="progress-wrapper">
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </div>
                    </v-card>
                </v-flex>
                <v-flex v-if="noMoreResult">
                    <div class="no-result-message text--secondary">
                        No more result
                    </div>
                </v-flex>
            </v-layout>
            <div v-infinite-scroll="loadMore"
                 infinite-scroll-distance="10"
            ></div>
        </v-flex>
        <v-flex lg3 md4 sm12 xs12 order-lg2 order-md2 order-sm1 order-xs1>
            <v-card class="media-filter-card">
                <v-card-text class="media-filter-container px-0">
                    <span class="body-2 px-3">Medias</span>
                    <v-text-field
                        v-model="searchMedias"
                        class="mt-2 px-3"
                        hide-details
                        clearable
                        label="Search Medias"
                    ></v-text-field>
                    <div v-if="filteredMedias.length == 0" class="text-xs-center pt-3">
                        <span class="font-weight-medium">No Medias Found</span>
                    </div>
                    <v-list dense v-else>
                        <v-list-tile
                            :key="media.id"
                            avatar
                            v-for="media in filteredMedias"
                        >
                            <v-list-tile-action style="min-width: 30px;">
                                <v-checkbox
                                    v-model="selectedMedias"
                                    :value="media.id"
                                    color="primary"
                                    hide-details
                                    @change="filterMediaChanged"
                                ></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-avatar size="30" style="min-width: 40px; border-radius: 0;">
                                <v-img :src="media.logoLink" style="border-radius: 0;"></v-img>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ media.name }} 
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <!-- <v-list-tile-action style="min-width: 30px;">
                                <v-chip 
                                    color="journal_color" 
                                    text-color="white" 
                                    style="margin-right: auto;"
                                    label
                                    small
                                >{{ media.count }}</v-chip>
                            </v-list-tile-action> -->
                        </v-list-tile>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-flex>

        <v-dialog
                v-model="dashboardLoading"
                hide-overlay
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    Loading...
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import JournalEntry from "../components/JournalEntry";
    import LineChart from "../components/LineChart";
    import SearchStats from "../components/SearchStats";
    import { mapActions, mapState, mapMutations } from "vuex";
    import { fontService } from '../services/font.services';
    import axios from 'axios'
    import moment from 'moment';
    import keywords from '../mixins/keywords';
    import current_user from "../mixins/current_user";
    import ImageBarChart from "../components/ImageBarChart";

    export default {
        components: {
            JournalEntry,
            LineChart,
            SearchStats,
            ImageBarChart,
        },

        mixins: [ keywords, current_user ],

        data() {
            return {
                selectedMedias:[],
                searchMedias: "",
                types: [
                    {
                        text: 'All',
                        value: undefined
                    },
                    {
                        text: 'Daily',
                        value: 'Daily'
                    },
                    {
                        text: 'Weekly',
                        value: 'Weekly'
                    },
                    {
                        text: 'Monthly',
                        value: 'Monthly'
                    }
                ],
                filter: {
                    keyword: null,
                    mediaIds: []
                },
                currentDashboard: null,
                dashboardLoading: false,
                mentionLineChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    callback: (value) => this.mentionLineChartHandler.handleLabel(value)
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                        callbacks: {
                            title: item => this.mentionLineChartHandler.handleTitle(item[0].label)
                        }
                    }
                },
                mediaBasedCountsBarChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    layout: {
                        padding: {
                            bottom: 15
                        }
                    },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false
                                },
                                barThickness: 20,
                                ticks: {
                                    callback: value => value.name
                                }
                            }
                        ],
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    barThickness: 3,
                                    padding: 18,
                                }
                            }
                        ]
                    },
                    tooltips: {
                        xAlign: 'center',
                        yAlign: 'top',
                        callbacks: {
                            title: (tooltipItem, data) => {
								return data.labels[tooltipItem[0].index].name;
							}
                        }
                    }
                }
            }
        },

        methods: {
            reloadSearch() {
                this.resetSearch();
                this.searchJournals();
                this.getSearchStats();
                this.getMentionChartData();
                this.getMediaBasedCountData();
            },

            searchKeywordInput(event) {
                if (event.keyCode === 13) 
                    this.searchKeywordChanged();
            },
            
            searchKeywordChanged() {
                const searchFilter = Object.assign({}, this.searchFilter);

                const raw_keyword = this.filter.keyword;
                if (raw_keyword) {
                    const deFont = fontService.detect(raw_keyword);
                    const converted = deFont === 'unicode' 
                        ? raw_keyword 
                        : fontService.convertToUni(raw_keyword);

                    searchFilter.keywords = [ converted ];
                } else {
                    searchFilter.keywords = [];
                }

                this.setSearchFilter(searchFilter);

                if (raw_keyword) {
                    this.$ua.trackEvent('Search', 'search', 
                        `${this.currentUser.username || 'User'} searched ${raw_keyword}`);
                }
            },

            searchKeywordCleared() {
                const searchFilter = Object.assign(
                    {}, 
                    this.searchFilter,
                    { keywords: [] }
                );
                this.setSearchFilter(searchFilter);
            },

            filterTypeChanged(type) {
                const typeVal = this.types
                    .find(typ => typ.text === type).value;
                const filter = Object.assign(
                    {}, 
                    this.searchFilter,
                    { type: typeVal }
                );
                this.setSearchFilter(filter);
            },

            filterMediaChanged() {
                const sf = Object.assign({}, this.searchFilter);
                sf.mediaIds = [...this.selectedMedias];
                this.setSearchFilter(sf);
            },

            onJournalDeleted(journalId) {
                if (confirm("Are you sure to delete?")) {
                    this.$ua.trackEvent('DeleteJournal', 'click', `${this.currentUser.username || 'User'} deleted ${journalId}`);
                    this.deleteJournal(journalId)
                        .catch(({ response }) => {
                            const msg = response.data.message;
                            if (msg == 'Can only delete before 3 days!') {
                                alert(msg);
                            }
                        });
                }
            },

            onJournalClicked(journal) {
                const param = { path: `/journals/${journal.externalId}` };

                if (
                    this.searchFilter.keywords != null && 
                    this.searchFilter.keywords.length > 0
                ) {
                    param.query = { keywords: this.searchFilter.keywords }
                }

                const routeData = this.$router.resolve(param);
                window.open(routeData.href, '_blank');
            },

            loadMore() {
                if (
                    !this.isLoading && 
                    this.foundJournals.length !== this.searchStats.journals
                ) {
                    this.searchJournals();
                }
            },

            getCurrentDashboard() {
                this.dashboardLoading = true
                axios.get(process.env.VUE_APP_API_URL + 'dashboards/' + this.dashboardId)
                    .then(({ data }) => {
                        this.dashboardLoading = false;

                        if (data) {
                            this.currentDashboard = data;
                            const searchFilter = Object.assign(
                                {}, 
                                this.searchFilter, 
                                { 
                                    keywords: this.currentDashboard.keywords,
                                    type: null
                                }
                            );

                            this.setSearchFilter(searchFilter);
                        }
                    });
            },

            ...mapMutations('search', ['setSearchFilter']),

            ...mapActions('search', [
                'searchJournals',
                'deleteJournal',
                'getSearchStats',
                'resetSearch',
                'getMentionChartData',
                'getMediaBasedCountData'
            ]),
        },

        mounted() {
            if (this.dashboardId) {
                this.getCurrentDashboard();
            } else {
                this.searchKeywordCleared();
            }
        },

        computed: {
            filteredMedias() {
                // const searchMedias = this.searchMedias;
                // const medias = this.medias.map(media => {
                //     const found = this.mediaBasedCountData.find(count => count.media.id === media.id);
                //     media.count = found ? found.journalsCount : 0;
                //     return media;
                // })
                // .filter(media => media.count > 0)
                // .sort((media1, media2) => media2.count - media1.count);
                // return searchMedias ? medias.filter(media => media.name.toLowerCase().includes(searchMedias.toLowerCase())) : medias;
                
                const searchMedias = this.searchMedias;
                if (searchMedias) {
                    return this.medias.filter(media => media.name.toLowerCase().includes(this.searchMedias.toLowerCase()));
                } else {
                    return this.medias;
                }
            },

            ...mapState('medias', [
                'medias'
            ]),

            ...mapState('search', [
                'searchStats',
                'searchFilter',
                'foundJournals',
                'mentionChartData',
                'mentionChartInterval',
                'mediaBasedCountData'
            ]),

            ...mapState('search', {
                isLoading: 'searchLoading'
            }),

            showNoResult() {
                return !this.isLoading
                    && this.foundJournals.length === 0
                    && this.searchStats.journals === this.foundJournals.length
            },

            noMoreResult() {
                return this.foundJournals.length === this.searchStats.journals
                    && this.foundJournals.length !== 0
            },

            dashboardId() {
                return this.$route.params.id
            },

            mediaBasedCountsBarChartData() {
                const labels = [];
                const data = [];

                this.mediaBasedCountData.filter(count => {
                    if (this.selectedMedias.length > 0) {
                        return this.selectedMedias.findIndex(media_id => count.media.id == media_id) > -1;
                    }
                    return true;
                })
                .slice(0, 10).forEach(count => {
                    labels.push(count.media);
                    data.push(count.journalsCount);
                });

                return {
                    labels,
                    datasets: [
                        {
                            label: "Journals",
                            backgroundColor: "#26AFDC",
							data
                        }
                    ]
                }
            },

            mentionLineChartData() {
                const pagesData = [];
                const journalsData = [];
                const mediasData = [];

                const labels = [];

                for (let key in this.mentionChartData) {
                    labels.push(key);

                    const { 
                        pages, 
                        journals, 
                        medias 
                    } = this.mentionChartData[key];

                    pagesData.push(pages);
                    journalsData.push(journals);
                    mediasData.push(medias);
                }

                // Hard coding. Fix later!
                if (labels.length === 1) {
                    const key = labels[0] + "";

                    labels.splice(0, 0, `${key} 6AM`, `${key} 7AM`);
                    pagesData.splice(0, 0, 0, 0);
                    journalsData.splice(0, 0, 0, 0);
                    mediasData.splice(0, 0, 0, 0);

                    labels.splice(2, 1, `${key} 8AM`);

                    labels.splice(3, 0, `${key} 9AM`, `${key} 10AM`);
                    pagesData.splice(3, 0, 0, 0);
                    journalsData.splice(3, 0, 0, 0);
                    mediasData.splice(3, 0, 0, 0);
                }

                return {
                    datasets: [
                        {
                            label: "Pages",
                            data: pagesData,
                            borderColor: "#cd212a",
                            backgroundColor: "#cd212a",
                            fill: false
                        },
                        {
                            label: "Journals",
                            data: journalsData,
                            borderColor: "#26AFDC",
                            backgroundColor: "#26AFDC",
                            fill: false
                        },
                        {
                            label: "Medias",
                            data: mediasData,
                            borderColor: "#4ec5a5",
                            backgroundColor: "#4ec5a5",
                            fill: false
                        }
                    ],
                    labels
                }
            },

            mentionLineChartHandler() {
                const size = Object.keys(this.mentionChartData).length;

                if (size === 1) {
                    const commonHandle = lbl => {
                        const splitLbl = lbl.split(' ');
                        return `${moment(splitLbl[0]).format('MMM DD')} ${splitLbl[1]}`;
                    }

                    return {
                        handleLabel: lbl => commonHandle(lbl),

                        handleTitle: title => commonHandle(title),
                    }
                } else {
                    return {
                        handleLabel: lbl => moment(lbl).format('MMM DD'),

                        handleTitle: title => {
                            const srtDate = moment(title);
                            const endDate = moment(this.mentionChartData[title].range[1]);
                            return `${srtDate.format('MMM DD')} - ${endDate.format('MMM DD')}`;
                        }
                    }
                }
            },
        },

        filters: {
            date(dateInMilli) {
                return new Date(dateInMilli).toDateString();
            }
        },

        watch: {
            dashboardId() {
                if (this.dashboardId) {
                    this.getCurrentDashboard();
                } else {
                    this.searchKeywordCleared();
                }
            },

            searchFilter() {
                this.reloadSearch();
            },
        }
    }
</script>

<style scoped>
    .media-logo-container {
        margin-left: 5px;
        margin-right: 10px;
    }

    .page-index-container {
        margin: 10px;
    }

    .search-btn {
        margin: 0;
        width: 100%;
        height: 100%;
    }

    @media only screen and (max-width: 599px) {
        .search-btn {
            height: 48px;
        }
    }

    .progress-wrapper {
        padding: 5px 20px;
    }

    .media-filter-card {
        margin-top: 56px;
    }

    @media only screen and (max-width: 959px) {
        .media-filter-container {
            max-height: 250px;
            overflow-y: scroll;
        }

        .media-filter-card {
            margin-top: 0;
        }
    }

    .stats {
        margin-left: 8px;
    }

    .no-result-message {
        font-size: 13px;
        font-weight: bold;
        padding: 8px;
        text-align: center;
    }

    .keywords-wrapper {
        padding: 4px 20px;
    }

    .keywords-caption {
        margin-right: 10px;
    }
</style>
